// Central type → color/style mapping used across NeuCounters, Transactions, RecentTransactions
export const TYPE_STYLES = {
  expense: { color: "#dc2626", sign: "-" },     // red
  income: { color: "#16a34a", sign: "+" },       // green (recurring salary)
  revenue: { color: "#0ea5e9", sign: "+" },      // sky-blue (one-time revenue)
  savings: { color: "#f5b800", sign: "+" },      // yellow
  borrow: { color: "#7c3aed", sign: "+" },       // purple
  lend: { color: "#0891b2", sign: "+" },         // turquoise
  recurring: { color: "#4f46e5", sign: "-" },    // indigo
  repay_borrow: { color: "#be123c", sign: "-" }, // rose (cash out - paying debt)
  repay_lend: { color: "#059669", sign: "+" },   // emerald (cash in - loan repayment)
  transfer: { color: "#64748b", sign: "⇄" },    // slate — neutral, no income/expense impact
  debt: { color: "#7c3aed", sign: "+" },         // legacy → borrow
};

export function styleFor(type) {
  return TYPE_STYLES[type] || TYPE_STYLES.expense;
}
